/**
 * Live /apply-now — same flow as /apply-loan
 *   Mobile OTP → PAN + DigiLocker Aadhaar → Loan form → Thank You
 *
 * Differences from /apply-loan:
 *   - DigiLocker opens in the same tab (no popup)
 *   - State / city / pincode are not prefilled from Aadhaar
 *
 * Previous OTP flow snapshot:
 *   apply-now-YESIFILE-backup-otp-before-digilocker-20260905.js
 */
import React from "react";
import ApplyLoan from "./apply-loan";

const ApplyNow = () => <ApplyLoan sameTabDigilocker prefillLocation={false} />;

export default ApplyNow;
